// UpCart-Style Smooth Animation System
document.addEventListener('DOMContentLoaded', function() {
  
  // Custom Event für Cart Updates (wie UpCart)
  function fireCartRefreshEvent() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', { detail: { cart: cart } })
        );
      })
      .catch(console.error);
  }
  
  // Lausche auf das cart:refresh Event
  document.documentElement.addEventListener('cart:refresh', function(event) {
    updateProgressBarSmooth(event.detail.cart);
  });
  
  function updateProgressBarSmooth(cart) {
    const progressContainer = document.querySelector('.free-shipping-progress');
    const progressBar = document.querySelector('.upcart-rewards-bar-foreground');
    const progressText = document.querySelector('.free-shipping-text');
    const progressBackground = document.querySelector('.upcart-rewards-bar-background');
    
    if (!progressContainer || !progressBar || !progressText || !progressBackground) return;
    
    const threshold = parseInt(progressContainer.dataset.threshold);
    const newTotal = cart.total_price;
    const newPercentage = Math.min((newTotal / threshold) * 100, 100);
    const remaining = threshold - newTotal;
    
    // Update Progress Bar (CSS transition macht es smooth)
    progressBar.style.width = newPercentage + '%';
    
    // Verstecke/Zeige Progress Bar je nach Status
    if (remaining <= 0) {
      progressBackground.style.display = 'none';
    } else {
      progressBackground.style.display = 'block';
    }
    
    // Update Text
    updateTextSmooth(remaining, progressText);
    
    // Update data attribute
    progressContainer.dataset.cartTotal = newTotal;
  }
  
  function updateTextSmooth(remaining, element) {
    element.style.opacity = '0.6';
    
    setTimeout(() => {
      if (remaining > 0) {
        const remainingEuro = (remaining / 100).toFixed(2).replace('.', ',');
        element.innerHTML = `Noch ${remainingEuro}€ bis zum kostenlosen Versand`;
        element.className = 'free-shipping-text';
        element.style.color = '#333';
        element.style.fontWeight = '600';
        element.style.backgroundColor = '';
        element.style.border = '';
        element.style.borderRadius = '';
        element.style.padding = '';
      } else {
        element.innerHTML = `
          <svg width="16" height="16" style="vertical-align: text-bottom; margin-right: 6px;" viewBox="0 0 24 24" fill="none">
            <path d="M9 12l2 2 4-4" stroke="#155724" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
            <circle cx="12" cy="12" r="10" stroke="#155724" stroke-width="2" fill="none"/>
          </svg>
          Du erhältst kostenlosen Versand!
        `;
        element.className = 'free-shipping-text success';
        element.style.color = '';
        element.style.fontWeight = '';
        element.style.backgroundColor = '';
        element.style.border = '';
        element.style.borderRadius = '';
        element.style.padding = '';
      }
      element.style.opacity = '1';
    }, 200);
  }
  
  // Überwache Quantity-Änderungen und feuere cart:refresh Event
  function setupCartListeners() {
    // Plus/Minus Buttons
    document.querySelectorAll('.quantity__button').forEach(button => {
      button.addEventListener('click', function() {
        setTimeout(() => {
          fireCartRefreshEvent();
        }, 300);
      });
    });
    
    // Quantity Input Fields
    document.querySelectorAll('input[data-quantity-variant-id]').forEach(input => {
      input.addEventListener('change', function() {
        setTimeout(() => {
          fireCartRefreshEvent();
        }, 300);
      });
    });
    
    // Remove Buttons
    document.querySelectorAll('.cart-remove-button').forEach(button => {
      button.addEventListener('click', function() {
        setTimeout(() => {
          fireCartRefreshEvent();
        }, 300);
      });
    });
  }
  
  // Initial Setup
  setupCartListeners();
  
  // Re-setup when cart content changes
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length > 0) {
        const hasCartContent = Array.from(mutation.addedNodes).some(node => 
          node.nodeType === 1 && 
          (node.querySelector && node.querySelector('.quantity__button, input[data-quantity-variant-id], .cart-remove-button'))
        );
        if (hasCartContent) {
          setTimeout(setupCartListeners, 100);
        }
      }
    });
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  // Cart Drawer Öffnen überwachen - FIX FÜR DAS PROBLEM!
  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-cart-drawer-toggle]') || e.target.closest('.cart-icon-bubble')) {
      setTimeout(() => {
        fetch('/cart.json')
          .then(response => response.json())
          .then(cart => {
            updateProgressBarSmooth(cart);
          })
          .catch(console.error);
      }, 200);
    }
  });
  
  // Sofort beim Laden ausführen
  setTimeout(() => {
    fetch('/cart.json')
      .then(response => response.json())
      .then(cart => {
        updateProgressBarSmooth(cart);
      })
      .catch(console.error);
  }, 500);
  
  // Fire initial event
  setTimeout(fireCartRefreshEvent, 100);
});